import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom'
import FlashMessages, {FlashMessageData} from '../../components/flashMessages.js'
import GoogleAuthButton from '../../components/googleAuthButton.js'
import SuccessfullAccountCreation from '../../components/successfullAccountCreation.js'
import {useAuth} from '../../helpers/authContext.js'
import {useLogin} from '../../helpers/loginContext.js'
import sharedPOST from '../../helpers/sharedFetch.js'

import Register from '../Register/index.js';
import ResetPassword from '../ResetPassword/index.js';
import ConfirmEmailCode from '../ConfirmEmailCode/index.js'
import CreateAccount from '../CreateAccount/index.js'

import {APIResponse} from '../../../../server/routes/route-types.js'
import {RtApiResult, RtOTPCodeRequestResult} from '../../../../server/routes/user.js'

// Interface for user data from Google login
interface UserData {
    name: string;
    email: string;
}

// Interface for Google login success callback
interface GoogleLoginSuccessParams {
    name: string;
    email: string;
    accountCreated: boolean;
}

// Interface for login parameters
interface LoginParams {
    email: string;
    password: string;
}

export default function Login() {

    // const {setUser} = useAuth(); 
    // const {setLoginType} = useLogin();
    const [showSuccessfullAccountCreation, setShowSuccessfullAccountCreation] = useState<boolean>(false);
    const [showAccountCreateDialog, setShowAccountCreateDialog] = useState<boolean>(false);
    const [userData, setUserData] = useState<UserData>({} as UserData)

    function handleLoginSuccess() {
        window.location.reload();
        // setLoginType(null);
        // setUser(true);
    }

    function handleGoogleLoginSuccess({name, email, accountCreated}: GoogleLoginSuccessParams) {

        if (!accountCreated) {
            setUserData({
                name,
                email
            })
            setShowAccountCreateDialog(true);
        }
        else {
            // account already created
            window.location.reload();
        }
    }

    function handleGoogleAccountCreated() {
        setShowSuccessfullAccountCreation(true)
    }

    if (showSuccessfullAccountCreation) {
        return (<SuccessfullAccountCreation message='You have successfully logged in and can now use your account. This page will refresh in a few seconds'/>)
    }
    if (showAccountCreateDialog) {
        return (
            <CreateAccount 
                name={userData.name} 
                email={userData.email} 
                onAccountCreated={handleGoogleAccountCreated} 
            />)
    }

	return (<>
        <h4 className="text-center mb-3">
            <b>
                Login
            </b>
        </h4>
        <div>
        {  /*  <FacebookLogin />*/}
            <GoogleAuthButton buttonText='Log in with Google' onSuccess={handleGoogleLoginSuccess}/>
        </div>
        <br/>
        <LoginWithEmailSeparator />
        <LoginWithEmailForm onSuccess={handleLoginSuccess}/>
        <br/>
        <OrLine />
        <BottomLoginPanel />
    </>)
}

function SuccessfullCreatedAccountMessage() {

    useEffect(() => {
        setTimeout(() => {
            window.location.reload();
        }, 
        2000);
    })

    return (<>
        <div>
            <div>
                <FlashMessages props={{success_msg:"You have successfully logged in and can now use your account. This page will refresh in a few seconds"}} />
            </div>
        </div>
    </>)
}

function LoginWithEmailSeparator() {

    return (<>
        <div className="or-line with-line ng-scope" >
            <div style={{textAlign: 'center'}}>
                <small>
                    Or log in with email
                </small>
            </div>
        </div>
    </>)

}

// Interface for LoginWithEmailForm props
interface LoginWithEmailFormProps {
    onSuccess: () => void;
}

function LoginWithEmailForm({onSuccess}: LoginWithEmailFormProps) {

    const [flashProps, setFlashProps] = useState<FlashMessageData>({}) 
    const [showEnterEmailVerificationCode, setShowEnterEmailVerificationCode] = useState<boolean>(false);

    function handleEmailLoginSubmit(params: LoginParams) {

        setFlashProps({});

        sharedPOST(
            '/user/login',
            {...params},
            {
                onSuccess: function (untypedResponse: unknown) {
                    const response = untypedResponse as APIResponse<RtOTPCodeRequestResult>;
                    if (response.results!.optCodeRequested) {
                        setShowEnterEmailVerificationCode(true);
                    }
                    else {
                        onSuccess(); 
                    }
                },
                onError: function (error: string) {
                    setFlashProps({error: error});
                }
            }
        )
    }

    function handleConfirmCode(emailCode: string) {

        setFlashProps({});
    
        sharedPOST(
            '/user/confirm-email-account-activate',
            {
                otpCode: emailCode
            },
            {
                onSuccess: function (untypedResponse: unknown) {
                    const response = untypedResponse as APIResponse<RtApiResult>;
                    setFlashProps(response.results!);
                    onSuccess();
                },
                onError: function (err: string) {
                    setFlashProps({error: err});
                }
            }
        )
    }

    return (<>
            <div className="form-group">
                <FlashMessages props={flashProps} />
            </div>
            {
                showEnterEmailVerificationCode ?
                    <ConfirmEmailCode onConfirmCode={handleConfirmCode} />
                    :
                    <EmailLoginForm onSubmit={handleEmailLoginSubmit}/>
            }
    </>)

}

// Interface for EmailLoginForm props
interface EmailLoginFormProps {
    onSubmit: (params: LoginParams) => void;
}

function EmailLoginForm({onSubmit}: EmailLoginFormProps) {

    function handleSubmit(e: React.FormEvent<HTMLFormElement>) {  

        e.preventDefault();

        const form = e.currentTarget;
        const emailElement = form.elements.namedItem('email') as HTMLInputElement;
        const passwordElement = form.elements.namedItem('password') as HTMLInputElement;

        onSubmit({
            email: emailElement.value,
            password: passwordElement.value
        })
    }

    return (
        <form action="/user/login" onSubmit={handleSubmit}>
            <div className="form-group">
                <input
                    type="email"
                    id="email"
                    name="email"
                    className="form-control"
                    placeholder="Enter Email"
                />
            </div>
            <div className="form-group">
                <input
                    type="password"
                    id="password"
                    name="password"
                    className="form-control"
                    placeholder="Enter Password"
                />
            <br/>
            </div>
            <button type="submit" className="btn btn-primary btn-block">Login</button>
        </form>
    );
}

function FacebookLogin() {

    return (<>
        <div style={{marginBottom: '10px'}}>
            <a href="/auth/facebook"><button className="btn btn-block"><span className="fa fa-facebook"></span>&nbsp;&nbsp;Log in with Facebook</button></a>
        </div>
    </>)
}

function OrLine() {

    return (<>
        <div className="or-line with-line ng-scope" >
            <div style={{textAlign: 'center'}}>
                <small>Or</small>
            </div>
        </div>
    </>)

}

function BottomLoginPanel() {
    
    const {setLoginType} = useLogin();
    
    return (
    <table>
        <tbody>
            <tr>
                <td style={{textAlign:'left'}}>
                    <a 
                        style={{textDecoration: 'underline', cursor: 'pointer'}} 
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            setLoginType((<Register />))
                        }}
                    >
                        Create an account
                    </a>
                </td>
                <td style={{textAlign: 'right'}}>
                    <a 
                        style={{textDecoration: 'underline', cursor: 'pointer'}} 
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            setLoginType((<ResetPassword />))
                        }}
                    >
                        Forgot Password?
                    </a>
                </td>
            </tr>
        </tbody>

    </table>)
}
